import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { ICalendarFeedActivityPanel } from "ICalendarFeed/activity/ICalendarFeedActivityPanel";
import { ICalendarFeedDetailSection } from "ICalendarFeed/ICalendarFeedDetailSection";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const ICalendarFeedDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ICalendarFeedDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ICalendarFeedDetailSection
            iCalendarFeed={viewModel.iCalendarFeed}
            hasICalendarTemplates={viewModel.templateCount > 0}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <ICalendarFeedActivityPanel
            config={viewModel.activityPanelConfig}
            iCalendarFeedId={viewModel.iCalendarFeed.iCalendarFeedId}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default ICalendarFeedDetailApp;